import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import RoomList from './components/RoomList';
import RoomDetail from './components/RoomDetail';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<RoomList />} />
        <Route path="/room/:id" element={<RoomDetail />} />
      </Routes>
    </Router>
  );
}

export default App;